// removed by extract-text-webpack-plugin
module.exports = {"rounded-rect-button":"rounded-rect-button"};


//////////////////
// WEBPACK FOOTER
// ./components/UI/Form/_rounded-rect-button.scss
// module id = ./components/UI/Form/_rounded-rect-button.scss
// module chunks = 0